import React, { useState } from 'react';
import Text from '../../ui/Text';
import './../../css/BetRowView/BetRowView.scss';
import ViewOddsButton from '../../containers/ViewOddsButton';
import infoIcon from 'images/info.png';
import { NotificationManager } from 'react-notifications';
import Wrapper from '../../ui/Wrapper';

const BetRowView = ({
    children = null,
    market,
    marketName,
    isCustomBet,
    isFirstElement = false,
    spillerLabel = null,
}) => {
    const setDefaultStateForToggle = () => {
        return isCustomBet ? isFirstElement : true;
    };
    const [isToggle, setIsToggle] = useState(setDefaultStateForToggle());

    let arrow = isToggle ? (
        <i className="fa fa-chevron-up" aria-hidden="true" />
    ) : (
        <i className="fa fa-chevron-down" aria-hidden="true" />
    );

    const getButtonStyles = (length) => {
        if (length === 1) {
            return {
                width: '100%',
                paired: false,
            };
        } else {
            if (length % 2 === 0) {
                return {
                    width: 'calc(50% - 5px)',
                    paired: true,
                };
            } else {
                return {
                    width: 'calc(33% - 5px)',
                    paired: false,
                };
            }
        }
    };

    const showInfoNotification = (text, e) => {
        e.preventDefault();
        e.stopPropagation();
        NotificationManager.warning('', text, 7000);
    };

    const toggleHandle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsToggle(!isToggle);
    };

    const getButtons = (market) => {
        let hasDisabledMarket = [];

        market.itemList.map((item) => {
            if (item.odds === 1) {
                hasDisabledMarket.push(true);
            }
        });

        let calculatedButtonStyles = hasDisabledMarket.includes(true)
            ? getButtonStyles(market.itemList.length - hasDisabledMarket.length)
            : getButtonStyles(market.itemList.length);

        return market.itemList.map((item, key) => {
            return item.odds === 1 ? null : (
                <div
                    style={{
                        width: `${calculatedButtonStyles.width}`,
                    }}
                    className={`${
                        market.itemList.length > 3
                            ? calculatedButtonStyles.paired
                                ? 'long-row '
                                : 'long-row unpaired'
                            : ''
                    }`}
                    key={`button-wrapper` + key}
                >
                    <ViewOddsButton
                        marketId={market.marketId}
                        market={market}
                        item={item}
                        isCustomBet={isCustomBet}
                        isFullWidthButtons
                        shouldUpdateOdds={true}
                    />
                </div>
            );
        });
    };

    const getCustomBetRowView = (market) => {
        return market.map((elem, index) => {
            return (
                <Wrapper
                    width={'100%'}
                    flex
                    padding={'0'}
                    margin={index === 0 ? '0' : '30px 0 0'}
                    flexDirection={'column'}
                    align={'center'}
                    key={`${index}_CB_wrapper`}
                    boxSizing={'border-box'}
                >
                    <Text
                        size={'14'}
                        lh={'14'}
                        margin={'0 0 10px'}
                        padding={'0'}
                        align={'left'}
                        color={'#333333'}
                        bold
                    >
                        {elem.marketName}
                    </Text>
                    <Wrapper
                        width={'100%'}
                        flex
                        padding={'0'}
                        margin={'0'}
                        flexDirection={'row'}
                        justify={'space-between'}
                        flexAlign={'flex-start'}
                        flexBasis={'center'}
                        flexWrap={'wrap'}
                        boxSizing={'border-box'}
                    >
                        {' '}
                        {getButtons(elem)}
                    </Wrapper>
                </Wrapper>
            );
        });
    };

    const betRowView =
        isCustomBet || market?.itemList.length > 0
            ? isCustomBet
                ? getCustomBetRowView(market, isCustomBet) //getCustomBetRowView(market, isCustomBet)
                : getButtons(market)
            : children !== null
                ? children
                : null;

    return (
        <>
            <div className="BetRowView">
                <div className="BetRowView__top" onClick={toggleHandle}>
                    <div className={'BetRowView__top-left'}>
                        <Text
                            size={'14'}
                            lh={'14'}
                            margin={'0'}
                            padding={'0'}
                            align={'left'}
                            color={'#333333'}
                            bold
                        >
                            {spillerLabel !== null ? spillerLabel : marketName}
                        </Text>
                        {market &&
                            market?.freeText && (
                                <img
                                    src={infoIcon}
                                    alt="info icon"
                                    onClick={(e) => {
                                        showInfoNotification(
                                            market?.freeText,
                                            e
                                        );
                                    }}
                                />
                            )}
                    </div>

                    <div className={'BetRowView__icon-wrapper'}>{arrow}</div>
                </div>
                <div className={`BetRowView__cont ${isToggle ? '' : 'hidden'}`}>
                    <div className={`BetRowView__buttons`}>{betRowView}</div>
                </div>
            </div>
        </>
    );
};

export default BetRowView;
